
import {
    FETCH_NOTIFICATION_ERROR,
    FETCH_NOTIFICATION_LOADING,
    FETCH_NOTIFICATION_SUCCESS,
    FETCH_ALL_NOTIFICATION_SUCCESS
} from "../action/index" 

const defaultState= {
    isLoading: false,
    messages: [],
    voicemails: [],
    error: null,
    data:[],
}

const notificationReducer = (state = defaultState, action ) => {
    let dupState = {...state}
    switch(action.type){
        case FETCH_ALL_NOTIFICATION_SUCCESS:
            return {...state, data: action.payload}
        case FETCH_NOTIFICATION_SUCCESS:
            return {...state, messages: action.payload.messages, voicemails: action.payload.voicemails, isLoading: false}
        case FETCH_NOTIFICATION_LOADING:
            return {...state, isLoading: true, error: null}
        case FETCH_NOTIFICATION_ERROR:
            return {...state, isLoading: false, error: "FETCH_NOTIFICATION_ERROR"}
        default:
            return {...state};
    }
}

export default notificationReducer;